import React, { FunctionComponent } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Box, Grid, Typography } from '@material-ui/core';
import Price from '../../../../../../../../gqlCommon/components/presentation/Price';
import usePlatformConfig from '../../../../../../../../common/react/usePlatformConfig';
import { selectedCurrencyVar } from '../../../../../../../../gqlCommon/graphql/cache';
import { usePersistedCurrencyPreference } from '../../../../../../../hooks/currency/usePersistedCurrencyPreference';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import { GetCustomizeCar_customizeCar_prices_carPrice_offers_discounts as IDiscount } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import useCarDiscountsPrices from '../../../../../../../hooks/prices/useCarDiscountsPrices';
import useSelectedCurrencyDiscountPrice from '../../../../../../../../gqlCommon/hooks/currency/useSelectedCurrencyDiscountPrice';
import summaryStyles from '../../../../summary/summarySection/SummaryStyles';

interface DiscountRowProps {
  loading: boolean;
  discount: IDiscount;
}

const DiscountRow: FunctionComponent<DiscountRowProps> = ({ loading, discount }) => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const discountedPrice = useCarDiscountsPrices(discount?.value);
  const { selectedCurrencyDiscountPrice } = useSelectedCurrencyDiscountPrice(discountedPrice);
  const priceType = isSecondaryCurrencyDisplay ? PriceDisplayType.SECONDARY : PriceDisplayType.PRIMARY;
  const decimals = isSecondaryCurrencyDisplay
    ? priceDisplay.secondaryOptions.decimalScale
    : priceDisplay.primaryOptions.decimalScale;
  const styles = summaryStyles();

  return (
    <Box className={styles.selectedOptionContainer} data-test={`summary:expanded:discount:${discount.code}`}>
      <Grid container className={styles.selectedOptionTitlePrice}>
        <Typography variant="caption">{discount.label}</Typography>
        <Box className={styles.optionPriceWrapper} data-test="summary:expanded:discount:price">
          {!loading && <Typography variant="caption">-</Typography>}
          <Price
            loading={loading}
            price={selectedCurrencyDiscountPrice}
            currency={selectedCurrency}
            priceDisplayType={priceType}
            decimals={decimals}
            className={styles.optionPrice}
          />
        </Box>
      </Grid>
    </Box>
  );
};

export default DiscountRow;
